import axios from 'axios';

class StripeProductService {
    private static CACHE_KEY = 'stripe_products_available';
    private static cached: boolean | null = null;

    /**
     * Check if Stripe products are available
     * Uses in-memory cache first, then sessionStorage
     * Cache is cleared on page reload (SPA reload)
     */
    static async hasStripeProducts(): Promise<boolean> {
        // Check in-memory cache first
        if (this.cached !== null) {
            return this.cached;
        }

        // Make API call to check for Stripe products
        try {
            const response = await axios.get('/api/Stripe/HasProducts');
            const hasProducts = response.data === true;
            
            // Cache the result
            this.cached = hasProducts;
            
            return hasProducts;
        } catch (error) {
            console.error('Error checking Stripe products availability:', error);
            // Default to showing features if there's an error
            return true;
        }
    }

    /**
     * Clear the cache (useful for testing or after configuration changes)
     */
    static clearCache(): void {
        this.cached = null;
    }
}

export default StripeProductService;